import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar, Shield, Scale, FileDown, Users } from 'lucide-react';

const RESOURCES = [
  {
    title: "Airbnb Cleaning & Turnover Scheduling",
    description: "Stop missed cleanings and back-to-back turnover chaos",
    icon: Calendar,
    href: "/airbnb-cleaning-schedule-software"
  },
  {
    title: "Stop Double Bookings & Back-to-Back Panic",
    description: "Prevent overlapping guests and coordinate check-ins/check-outs",
    icon: Shield,
    href: "/stop-airbnb-double-bookings"
  },
  {
    title: "TurnoverBnB Alternative for Small Hosts",
    description: "Simpler coordination without enterprise PMS overhead",
    icon: Scale,
    href: "/turnoverbnb-alternative"
  },
  {
    title: "Free Airbnb Turnover Checklist (Printable)",
    description: "Download our printable cleaning checklist PDF",
    icon: FileDown,
    href: "/airbnb-turnover-checklist-free-download"
  },
  {
    title: "Cleaner Scheduling Tool for Airbnb / STR Hosts",
    description: "Give each cleaner a clear schedule with automatic reminders",
    icon: Users,
    href: "/cleaner-scheduling-tool-for-airbnb-hosts"
  }
];

export const ResourcesForHostsSection = () => {
  return (
    <section className="py-16 border-y">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">
            Resources for Short-Term Rental Hosts
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Practical guides and tools to help you manage cleanings, prevent double bookings, 
            and coordinate turnovers for your 1–50 listings.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {RESOURCES.map((resource, index) => {
            const Icon = resource.icon;
            return (
              <Link key={index} to={resource.href}>
                <Card className="h-full hover:shadow-lg transition-shadow hover:border-primary">
                  <CardHeader>
                    <div className="flex items-center gap-3 mb-2">
                      <div className="p-2 rounded-lg bg-primary/10">
                        <Icon className="w-5 h-5 text-primary" />
                      </div>
                    </div>
                    <CardTitle className="text-lg leading-tight hover:text-primary transition-colors">
                      {resource.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground">
                      {resource.description}
                    </p>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
